import React from 'react'

export const Role = ({ buRole, classes }) => {
  return (
    buRole && (
      <div className={classes}>
        {buRole === '0'
          ? 'Super Admin'
          : buRole === '1'
          ? 'System Admin'
          : buRole === '2'
          ? 'Finance System'
          : buRole === '3'
          ? 'Marketing/Logistics'
          : buRole === '4'
          ? 'Designer'
          : buRole === 'admin'
          ? 'Admin'
          : buRole === 'member'
          ? 'Member'
          : buRole === 'client'
          ? 'Client'
          : 'Other'}
      </div>
    )
  )
}

Role.displayName = 'r'

export default Role
